import {
  createAlignPlugin,
  createBoldPlugin,
  createHeadingPlugin,
  createItalicPlugin,
  createParagraphPlugin,
  createLinkPlugin,
  createExitBreakPlugin,
  createFontBackgroundColorPlugin,
  createFontColorPlugin,
  createFontSizePlugin,
  createStrikethroughPlugin,
  createUnderlinePlugin,
  createHorizontalRulePlugin,
  createMediaEmbedPlugin,
  createNodeIdPlugin,
  createIndentPlugin,
  createPlugins,
  createResetNodePlugin,
  createTrailingBlockPlugin,
  ELEMENT_PARAGRAPH,
} from '@udecode/plate';
// import { createBlockSelectionPlugin, BlockSelectable } from '@udecode/plate-selection';
import { createDndPlugin } from '@udecode/plate-dnd';

import { createErrorHandlingPlugin } from '../plugins/error/createErrorHandlingPlugin';
import { createMCENormalizerPlugin } from '../plugins/normalizers/createMCENormalizerPlugin';
import { createFontFamilyPlugin } from '../plugins/fonts/createFontFamilyPlugin';
import { createTodoListPlugin } from '../plugins/todo-list/createTodoListPlugin';
import { createTablePlugin } from '../plugins/table/createTablePlugin';
import { createImagePlugin } from '../plugins/media/images/createImagePlugin';
import { createPageBreakPlugin } from '../plugins/page-break/createPageBreakPlugin';
import { indentPlugin } from '../plugins/indent/indentPlugin';
import { createListPlugin } from '../plugins/list/createListPlugin';
import { listPlugin, listPluginByKey } from '../plugins/list/listPlugin';
import { linkPlugin } from '../plugins/link/linkPlugin';
import { mediaEmbedPlugin } from '../plugins/media/embed/mediaEmbedPlugin';
import { fontColorPlugin } from '../plugins/fonts/fontColorPlugin';
import { fontSizePlugin } from '../plugins/fonts/fontSizePlugin';
import { fontBackgroundColorPlugin } from '../plugins/fonts/fontBackgroundColorPlugin';
import { PlateFloatingLink } from '../components/popup/FloatingLink/PlateFloatingLink';
import { withStyledDraggables } from '../plugins/dnd/withStyledDraggables';
import { plateUI, serializePlateUI } from '../plateUI';
import { VALID_ALIGNMENT_TYPES } from '../plugins/alignment/constants';
import { SerializedTodoElement } from '../plugins/todo-list/ToDoListElement';
import { createNoteLayoutPlugin } from '../plugins/layout/note-layout/createNoteLayoutPlugin';
import { createFakeSelectionPlugin } from '../plugins/fake-selection/createFakeSelectionPlugin';
import { resetNodePlugin } from '../plugins/reset-node/resetNodePlugin';

import '../components/popup/floating.scss';

const components = withStyledDraggables(plateUI);

export const plugins = createPlugins(
  [
    createMCENormalizerPlugin(),
    createTrailingBlockPlugin({ level: 0, type: ELEMENT_PARAGRAPH }),
    createErrorHandlingPlugin(),
    createResetNodePlugin(resetNodePlugin),
    createParagraphPlugin(),
    createHeadingPlugin(),
    createAlignPlugin({
      inject: {
        props: {
          validTypes: VALID_ALIGNMENT_TYPES,
        },
      },
    }),
    createImagePlugin(),
    createMediaEmbedPlugin(mediaEmbedPlugin),
    createListPlugin(listPlugin, listPluginByKey),
    createTodoListPlugin(),
    createLinkPlugin({ ...linkPlugin, renderAfterEditable: PlateFloatingLink }),
    createTablePlugin(),

    createBoldPlugin(),
    createItalicPlugin(),
    createUnderlinePlugin(),
    createStrikethroughPlugin(),

    createExitBreakPlugin(),
    createFontBackgroundColorPlugin(),
    createFontColorPlugin(),
    createFontFamilyPlugin(),
    createFontSizePlugin(),
    createHorizontalRulePlugin(),
    createPageBreakPlugin(),

    createIndentPlugin(indentPlugin),

    createNodeIdPlugin(),
    createDndPlugin({ options: { enableScroller: true } }),
    createFakeSelectionPlugin(),
    createNoteLayoutPlugin(),
  ],
  { components },
);

export const serializedPlugins = [
  createMCENormalizerPlugin(),
  createParagraphPlugin(),
  createHeadingPlugin(),
  createAlignPlugin({
    inject: {
      props: {
        validTypes: VALID_ALIGNMENT_TYPES,
      },
    },
  }),
  createImagePlugin(),
  createMediaEmbedPlugin(mediaEmbedPlugin),
  createListPlugin(listPlugin, listPluginByKey),
  createTodoListPlugin({
    serializeHtml: SerializedTodoElement,
  }),
  createLinkPlugin({ ...linkPlugin, renderAfterEditable: PlateFloatingLink }),
  createTablePlugin(),

  createBoldPlugin(),
  createItalicPlugin(),
  createUnderlinePlugin(),
  createStrikethroughPlugin(),

  createExitBreakPlugin(),
  createFontBackgroundColorPlugin(fontBackgroundColorPlugin),
  createFontColorPlugin(fontColorPlugin),
  createFontFamilyPlugin(),
  createFontSizePlugin(fontSizePlugin),
  createHorizontalRulePlugin(),
  createPageBreakPlugin(),

  createIndentPlugin(indentPlugin),

  createNodeIdPlugin(),
  createDndPlugin({ options: { enableScroller: true } }),

  createNoteLayoutPlugin(),

  { components: serializePlateUI },
];
